module.exports = "<article class=\"weui_article\">\n  <slot></slot>\n</article>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/article.vue
 ** module id = 113
 ** module chunks = 0
 **/